import React from 'react'
import { useTranslation } from 'react-i18next';

export default function Navigate_Logged() {

	const { t, i18n } = useTranslation();
	const changeLanguage = lng => {
		i18n.changeLanguage(lng);
		localStorage.setItem("mk_lang", lng);
	};
	function logout() {
		localStorage.clear();
	}
	return (
		<nav className="navbar navbar-expand-sm navbar-light sticky-top " style={{ backgroundColor: "#000000" }}>
			<div className="container-fluid container ">
				<div>
					<a href="/user" className="navbar-brand">
						<img src="media/logo_miyazaki.jpeg" alt="Miyazaki"></img>
					</a>
				</div>
				<button className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarToggle" style={{ border: "none", background: "none", color: "#d4d2cd" }}>
					<i class="fas fa-bars"></i>
				</button>
				<div className="collapse navbar-collapse " id="navbarToggle">
					<ul className="navbar-nav ms-auto">
						<li className="nav-item"><a href="/" className="nav-link" onClick={logout} style={{ border: "none", background: "none", color: "#d4d2cd" }}>
							<i className="fas fa-sign-out-alt"></i>
							<label style={{ border: "none", background: "none", color: "#d4d2cd" }}>
								{t('logout')}
							</label>
						</a></li>
						<li className="nav-item respon-pc">
							<button className="nav-link" style={{ border: "none", background: "none" }} onClick={() => changeLanguage('la')}>
								<i className="flag-icon flag-icon-la"></i>
							</button>
						</li>
						<li className="nav-item respon-pc" >
							<button className="nav-link" style={{ border: "none", background: "none" }} onClick={() => changeLanguage('en')}>
								<i className="flag-icon flag-icon-us"></i>
							</button>
						</li>
						<li className="nav-item respon-mb">
							<button className="nav-link" style={{ border: "none", background: "none" }} onClick={() => changeLanguage('la')}>
								<i className="flag-icon flag-icon-la"></i>
								&nbsp;
								<label style={{ border: "none", background: "none", color: "#d4d2cd" }}>ພາສາລາວ</label>
							</button>
						</li>
						<li className="nav-item respon-mb" >
							<button className="nav-link" style={{ border: "none", background: "none" }} onClick={() => changeLanguage('en')}>
								<i className="flag-icon flag-icon-us"></i>
								&nbsp;
								<label style={{ border: "none", background: "none", color: "#d4d2cd" }}>English</label>
							</button>
						</li>
					</ul>
				</div>
			</div>
		</nav>)
}
